<template>
  <div>
    <b-modal v-model="showModal" no-close-on-backdrop no-close-on-esc hide-header-close :id="theme"
      modal-class="kurua-modal" header-class="my-class" size="md" title="Create hospital" ref="modal-edit">
      <template #modal-header="{ close }" class="bg-dark">
        <p class="w-100 pt-3 text-center text-white h-100" size="sm" disabled variant="outline-danger">通知</p>
      </template>
      <form @submit.prevent="createNotification">
        <b-form-group class="mt-2">
          <label class="text-label">
            タイトル <span class="text-label-required bg-required-label badge badge-soft-danger font-size-11 me-2">必須</span>
          </label>
          <b-form-input v-model="notification.title" required></b-form-input>
        </b-form-group>

        <b-form-group class="mt-3">
          <label class="text-label">
            メッセージ <span class="text-label-required bg-required-label badge badge-soft-danger font-size-11 me-2">必須</span>
          </label>
          <b-form-textarea v-model="notification.message" rows="3" required></b-form-textarea>
        </b-form-group>

        <b-form-group class="mt-3">
          <label class="text-label">
            配信先  <span class="text-label-required bg-required-label badge badge-soft-danger font-size-11 me-2">必須</span>
          </label>
          <b-form-radio-group v-model="notification.user_type">
            <b-form-radio v-for="userType of userTypes" :value="userType.value" class="me-5"><span class="ps-2">{{ userType.text }}</span></b-form-radio>
          </b-form-radio-group>
          <b-form-select v-if="notification.user_type === 'facility'" class="form-select" v-model="notification.facility_id" :options="facilityNames" required></b-form-select>
        </b-form-group>

        <b-form-group class="mt-3">
          <label class="text-label">
            区分 <span class="text-label-required bg-required-label badge badge-soft-danger font-size-11 me-2">必須</span>
          </label>
          <b-form-select class="form-select" v-model="notification.type" :options="notificationTypes"></b-form-select>
        </b-form-group>

        <template v-if="notification.type === 'scheduled'">
          <b-form-group class="mt-3">
            <label class="text-label">
              送信日時 <span class="text-label-required bg-required-label badge badge-soft-danger font-size-11 me-2">必須</span>
            </label>
            <input type="datetime-local" class="form-control" v-model="notification.schedule_datetime" :min="now">
          </b-form-group>
        </template>

        <template v-if="notification.type === 'periodic'">
          <b-form-group class="mt-3">
            <label class="text-label">
              定期タイプ <span class="text-label-required bg-required-label badge badge-soft-danger font-size-11 me-2">必須</span>
            </label>
            <b-form-radio-group v-model="notification.periodic_type">
              <b-form-radio v-for="periodicType of periodicTypes" :value="periodicType.value" class="me-5">
                <span class="ps-2">{{ periodicType.text }}</span>
              </b-form-radio>
            </b-form-radio-group>
          </b-form-group>

          <div class="row">
            <template v-if="notification.periodic_type === 'daily'">
              <b-form-group class="mt-3 col-12">
                <label class="text-label">
                  時刻 <span class="text-label-required bg-required-label badge badge-soft-danger font-size-11 me-2">必須</span>
                </label>
                <input type="time" class="form-control" v-model="notification.periodic_time" />
              </b-form-group>
            </template>

            <template v-if="notification.periodic_type === 'weekly'">
              <b-form-group class="mt-3 col-6">
                <label class="text-label">
                  曜日 <span class="text-label-required bg-required-label badge badge-soft-danger font-size-11 me-2">必須</span>
                </label>
                <b-form-select class="form-select" v-model="notification.periodic_weekday" :options="weekdays"></b-form-select>
              </b-form-group>

              <b-form-group class="mt-3 col-6">
                <label class="text-label">
                  時刻 <span class="text-label-required bg-required-label badge badge-soft-danger font-size-11 me-2">必須</span>
                </label>
                <input type="time" class="form-control" v-model="notification.periodic_time" />
              </b-form-group>
            </template>
          </div>
        </template>

        <b-form-group class="mt-3">
          <label class="text-label">
            ステータス <span class="text-label-required bg-required-label badge badge-soft-danger font-size-11 me-2">必須</span>
          </label>
          <b-form-radio-group v-model="notification.status">
            <b-form-radio v-for="status of statuses" :value="status.value" class="me-5"><span class="ps-2">{{ status.text }}</span></b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </form>

      <template #modal-footer>
        <div class="w-100">
          <div class="row g-3">
            <div class="col-6" style="padding-right: 2px !important">
              <b-button class="w-100" type="button" @click="closeModal()" variant="outline-danger"> キャンセル </b-button>
            </div>
            <div class="col-6">
              <b-button type="button" :disabled="disabled()" @click="createNotification" class="w-100 btn-lyg"
                style="padding-left: 2px !important" variant="primary"> 保存 </b-button>
            </div>
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import api from "@/api/";

export default {
  name: 'CreateNotification',
  props: {
    showModal: {
      type: Boolean,
      required: true
    },
    theme: {
      type: String,
    }
  },
  data() {
    return {
      notification: this.defaultNotification(),
      userTypes: [
        { text: 'くるあユーザー  ', value: 'normal' },
        { text: 'くるあプラスユーザー  ', value: 'plus' },
        { text: '全員', value: 'all' },
        { text: '施設', value: 'facility' }
      ],
      notificationTypes: [
        { text: '今すぐ ', value: 'immediate' },
        { text: '後で送信', value: 'scheduled' },
        { text: '定期的に', value: 'periodic' }
      ],
      periodicTypes: [
        { text: '毎日', value: 'daily' },
        { text: '毎週', value: 'weekly' }
      ],
      // Weekdays value is ISO 8601.
      weekdays: [
        { text: '月曜日', value: 1 },
        { text: '火曜日', value: 2 },
        { text: '水曜日', value: 3 },
        { text: '木曜日', value: 4 },
        { text: '金曜日', value: 5 },
        { text: '土曜日', value: 6 },
        { text: '日曜日', value: 7 }
      ],
      statuses: [
        { text: '有効', value: 1 },
        { text: '無効', value: 0 }
      ],
      now: (new Date()).toISOString().substring(0, 16),
      facilityNames: [],
    }
  },

  created() {
    this.listFacility();
  },

  methods: {

    listFacility() {
      api.getListNameFacility().then((e) => {
        if (e.status === 200) {
          this.facilityNames = e.data.map(facility => ({
          text: facility.name,
          value: facility.id
        }));
        }
      });
    },

    defaultNotification() {
      return {
        title: '',
        message: '',
        user_type: 'normal',
        type: 'immediate',
        periodic_type: null,
        schedule_datetime: null,
        periodic_weekday: null,
        periodic_time: null,
        status: 1,
        facility_id: null,
      };
    },
    closeModal() {
      this.$emit('close');
      this.resetForm();
    },
    createNotification() {
      if (this.notification.type === 'immediate') {
        this.notification.periodic_type = null;
        this.notification.schedule_datetime = null;
        this.notification.periodic_weekday = null;
        this.notification.periodic_time = null;
      } else if (this.notification.type === 'scheduled') {
        this.notification.periodic_type = null;
        this.notification.periodic_weekday = null;
        this.notification.periodic_time = null;
      } else {
        this.notification.schedule_datetime = null;
        if (this.notification.periodic_type === 'daily') {
          this.notification.periodic_weekday = null;
        }
      }
      this.$emit('create', this.notification);
      this.resetForm();
    },
    resetForm() {
      this.notification = this.defaultNotification();
    },
    disabled() {
      return (
        !this.notification.title
        || !this.notification.message
        || (this.notification.type === 'scheduled' && !this.notification.schedule_datetime)
        || (this.notification.type === 'periodic' && !this.notification.periodic_type)
        || (this.notification.periodic_type === 'daily' && !this.notification.periodic_time)
        || (this.notification.periodic_type === 'weekly' && (!this.notification.periodic_weekday || !this.notification.periodic_time))
        || (this.notification.user_type === 'facility' && !this.notification.facility_id)
      );
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep .kurua-modal {
  .my-class {
    background: #395299 !important;
    font-weight: 700;
    color: #ffffff;
    font-size: 20px;
    height: 70px;
    line-height: 18px;
  }
}
</style>